import Immutable from 'immutable';
import UploadTypes from '~/constants/types/UploadTypes';

export function initialState() {
  return Immutable.fromJS({
    colorMode: null,
    error: null,
    iconId: null,
    originalImageHeight: null,
    originalImageWidth: null,
    spotColors: Immutable.List(),
    successful: null,
    uploading: false,
    url: null,
    viewId: null,
    uploadAndSwap: false
  });
}

export default function upload(state = initialState(), action) {
  switch (action.type) {
    case UploadTypes.UPLOAD_IN_PROGRESS:
      return state.merge({
        ...action.payload,
        error: null,
        successful: null,
        uploading: true
      });
    case UploadTypes.UPLOAD_FAILED:
      return state.merge({
        error: action.payload?.error,
        uploadType: action.payload?.uploadType,
        iconId: null,
        successful: false,
        uploading: false,
        url: null,
        viewId: null
      });
    case UploadTypes.UPLOAD_SUCCESS: {
      return state.merge({
        ...action.payload,
        error: null,
        successful: true,
        uploading: false
      });
    }
    case UploadTypes.RESET_PROGRESS:
      return initialState();
    default:
      return state;
  }
}
